import React from 'react';
import { useGoogleLogin } from '@react-oauth/google';
import toast, { Toaster } from 'react-hot-toast';
// Replace with your admin login API if needed
import { Logins } from '../composables/fetchAPI';
import { setToken } from '../composables/tokenManager';

const AdminLoginPage: React.FC<{ onLogin: (token: string) => void }> = ({ onLogin }) => {
  const login = useGoogleLogin({
    onSuccess: async tokenResponse => {
      try {
        // //console.log('Admin Token Response:', tokenResponse.access_token);
        // Call your admin login API here
        const info = await Logins(tokenResponse.access_token);

        setToken(info.access_token);
        onLogin(info);
        toast.success('เข้าสู่ระบบแอดมินสำเร็จ!');
        // //console.log('Admin Token ID:', info.access_token);
      } catch (e) {
        toast.error('เข้าสู่ระบบแอดมินล้มเหลว');
      }
    },
    onError: () => toast.error('Google Login ล้มเหลว'),
    scope: [
      "https://www.googleapis.com/auth/youtube.readonly",
      "https://www.googleapis.com/auth/youtube.channel-memberships.creator"
    ].join(" "),
    flow: "implicit",
  });

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-black text-gray-100">
      <Toaster />
      <img src="/piggy-usa.png" alt="Piggy Logo" className="w-64 h-64 mb-4" />
      <h1 className="text-3xl font-bold mb-6">Admin Login with Google</h1>
      <button
        onClick={() => login()}
        className="bg-red-500 text-white font-semibold px-6 py-2 rounded-lg shadow hover:bg-red-400 transition"
      >
        Login as Admin with Google
      </button>
      <div className="text-gray-400 text-center text-sm mt-4">
        ใช้บัญชี Google ที่ได้รับสิทธิ์แอดมินเท่านั้น
      </div>
    </div>
  );
};

export default AdminLoginPage;